import { createAction } from "redux-actions";

export const REVIEW_LIST = "REVIEW_LIST";
export const reviewList = createAction(REVIEW_LIST);

export const ADD_REVIEW = "ADD_REVIEW";
export const addReview = createAction(ADD_REVIEW);

export const DELETE_REVIEW = "DELETE_REVIEW";
export const deleteReview = createAction(DELETE_REVIEW);

export const REVIEW_LIST_FOR_PRODUCTS = "REVIEW_LIST_FOR_PRODUCTS";
export const reviewListForProduct = createAction(REVIEW_LIST_FOR_PRODUCTS);

export const PRODUCT_REVIEW_LIST = "PRODUCT_REVIEW_LIST";
export const productReviewList = createAction(PRODUCT_REVIEW_LIST);

export const REVIEW_DETAILS = "REVIEW_DETAILS";
export const reviewDetails = createAction(REVIEW_DETAILS);

export const UPDATE_REVIEW = "UPDATE_REVIEW";
export const updateReview = createAction(UPDATE_REVIEW);

// export const DELETE_REVIEW = "DELETE_REVIEW";
// export const deleteReview = createAction(DELETE_REVIEW);
